import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "./ui/card";

const SessionForm = ({ apps, onSubmit }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const getLocalDateTime = () => {
    const date = new Date();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset()); // Adjust for timezone
    return date.toISOString().slice(0, 16); // Format as YYYY-MM-DDTHH:MM
  };

  const [formData, setFormData] = useState({
    appId: '',
    date: getLocalDateTime(),
    gamesPlayed: '',
    startingSc: '',
    betSize: '',
    spinsHands: '',
    endingSc: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.appId || !formData.date || !formData.gamesPlayed || !formData.startingSc) {
      alert('Please fill in all required fields');
      return;
    }
    onSubmit(formData);
    setFormData({
      appId: '',
      date: getLocalDateTime(),
      gamesPlayed: '',
      startingSc: '',
      betSize: '',
      spinsHands: '',
      endingSc: ''
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Card style={{ backgroundColor: '#FFFFFF' }}>
      <CardHeader>
        <CardTitle>Add Session</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Casino *
              </label>
              <select
                name="appId"
                value={formData.appId}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              >
                <option value="">Select Casino</option>
                {apps?.map(app => (
                  <option key={app._id} value={app._id}>{app.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date In *
              </label>
              <input
                type="datetime-local"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Games Played *
              </label>
              <input
                type="text"
                name="gamesPlayed"
                value={formData.gamesPlayed}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Starting SC ($) *
              </label>
              <input
                type="number"
                name="startingSc"
                value={formData.startingSc}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                step="0.01"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Bet Size ($)
              </label>
              <input
                type="number"
                name="betSize"
                value={formData.betSize}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                step="0.01"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Spins/Hands
              </label>
              <input
                type="number"
                name="spinsHands"
                value={formData.spinsHands}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Ending SC ($)
              </label>
              <input
                type="number"
                name="endingSc"
                value={formData.endingSc}
                onChange={handleChange}
                className="w-full p-2 border rounded"
                step="0.01"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-3 rounded hover:bg-blue-600 transition-colors"
          >
            Add Session
          </button>
        </form>
      </CardContent>
    </Card>
  );
};

export default SessionForm;